// core
import React from 'react'
// libraries
import Helmet from 'react-helmet'
// translate
import { translate } from 'i18n'

interface IMetaProps {
  description?: string
  title?: string
  url?: string
  image?: string
}

export const Meta = ({
  description = '',
  title: _title,
  url = 'https://www.ambitas.org',
  image = 'https://www.ambitas.org/logo512.png',
}: IMetaProps) => {
  const title = `${_title ? `${_title} - ` : ''}${translate.i18n.COMPANY_NAME}`

  return (
    <Helmet>
      <title>{title}</title>
      <meta data-react-helmet="true" name="sitename" content={title} />
      <meta data-react-helmet="true" name="title" content={title} />
      <meta data-react-helmet="true" name="fb:title" content={title} />
      <meta data-react-helmet="true" property="og:title" content={title} />

      <meta data-react-helmet="true" name="description" content={description} />
      <meta data-react-helmet="true" name="og:description" content={description} />
      <meta data-react-helmet="true" name="fb:description" content={description} />
      <meta data-react-helmet="true" name="twitter:description" content={description} />

      <meta data-react-helmet="true" property="og:locale" content="en" />
      <meta data-react-helmet="true" property="og:url" content={url} />
      <meta data-react-helmet="true" property="og:image" content={image} />

      <meta data-react-helmet="true" name="twitter:card" content="summary_large_image" />
      <meta data-react-helmet="true" name="twitter:image" content={image} />

      <link data-react-helmet="true" rel="canonical" href={url} />
    </Helmet>
  )
}
